var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3880ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    className: "cls-1",
    d: "m50.07,27.57c-12.46,0-22.56,10.1-22.56,22.56s10.1,22.56,22.56,22.56,22.56-10.1,22.56-22.56c-.07-12.46-10.17-22.56-22.56-22.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle6",
    className: "cls-1",
    cx: 82.39,
    cy: 19.29,
    r: 10.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "cls-1",
    d: "m95.06,29.59l-.4-.94-.67.81c-1.68,1.89-3.84,3.37-6.2,4.24l-.67.27.27.67c2.09,4.92,3.1,10.17,3.1,15.49,0,22.29-18.12,40.48-40.48,40.48S9.59,72.43,9.59,50.13,27.71,9.66,50.07,9.66c6.06,0,11.85,1.35,17.31,3.91l.61.27.27-.67c1.01-2.36,2.56-4.38,4.58-5.99l.81-.67-.94-.47c-7.07-3.64-14.68-5.52-22.7-5.52C22.72.5.5,22.72.5,50s22.22,49.5,49.5,49.5,49.5-22.22,49.5-49.5c0-7-1.48-13.87-4.44-20.41h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.96a31be75e3e221c32206ef1b70d07f3.svg";
export { ForwardRef as ReactComponent };